"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MissingParkingIcon = MissingParkingIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function MissingParkingIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_5645_25724)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z",
    fill: "#E4F2DE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.758 23.3573C29.1932 22.9221 29.8982 22.9222 30.3335 23.3573C30.7686 23.7926 30.7687 24.4976 30.3335 24.9328L27.1076 28.1587L30.3335 31.3846C30.7686 31.8199 30.7687 32.525 30.3335 32.9602C29.8983 33.3952 29.1932 33.3952 28.758 32.9602L25.5321 29.7343L22.3062 32.9602C21.8709 33.3952 21.1659 33.3952 20.7306 32.9602C20.2956 32.5249 20.2956 31.8199 20.7306 31.3846L23.9565 28.1587L20.7306 24.9328C20.2954 24.4976 20.2956 23.7926 20.7306 23.3573C21.1659 22.922 21.8709 22.922 22.3062 23.3573L25.5321 26.5832L28.758 23.3573Z",
    fill: "#048760"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.9215 6.61963H12.6692C11.8485 6.61963 11.1831 7.285 11.1831 8.10577V25.892C11.1831 26.7127 11.8485 27.3781 12.6692 27.3781H14.1189C14.9397 27.3781 15.605 26.7127 15.605 25.892V20.4586H18.9215C22.5806 20.4586 25.5544 17.3564 25.5544 13.5391C25.5544 9.72187 22.5806 6.61963 18.9215 6.61963ZM19.1426 15.8456H15.605V11.2326H19.1426C20.3586 11.2326 21.3535 12.2705 21.3535 13.5391C21.3535 14.8077 20.3586 15.8456 19.1426 15.8456Z",
    fill: "#048760"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_5645_25724"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    fill: "white",
    height: "40",
    width: "40"
  }))));
}